(() => {
  const selector = '[data-rid="0ba906d8-27fd-4f42-9511-3d896f9447e8"], [data-rid="e0539d51-ee15-4d92-998c-51e9020386d3"]';
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest(selector)) return;
    const target = document.getElementById('shop-lifttech-pdp');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    history.replaceState(null, '', '#shop-lifttech-pdp');
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  }, true);
})();
